/*
  Vape Direct quick add for the theme's own collection and search cards (18 Oct 2026, replaces the Boost version of 12 Oct)

  - Hides the theme's "Choose options" button on every product card and puts a pink "Add +" pill (basket icon) to the right of the price.
  - Sold out: grey "Sold out" pill that does nothing.

  21 Oct 2026 (Joe): computers and phones now work differently.
  - Computers (screens 1024px and wider): the + opens a box over the lower part of the card, laid out like the Boost one
    on the old live site: "Choose options" and a close cross, the options as buttons (a drop down when an option has
    more than 8 values), sold out choices greyed out, then quantity and Add to basket on one row. A product with only one choice is added straight away and the pill
    says Added. Nothing else is loaded, only the product's own data (/products/handle.js, a few KB), and that is fetched
    when the mouse first moves over the card, so the box opens at once. After adding, the button says Added,
    the basket counts update and the box closes.
  - Phones and tablets (under 1024px): the + opens the theme's own quick shop pop-up, as before.

  The pop-up (phones and tablets):
  - The product's offer badges (3 For £12, 6 For £20 and so on) are added under the price, copied from the card so they always
    match. Joe wants the pop-up kept simple: title, price, deals, options, quantity, Add to basket. The theme's pickup
    availability block is hidden by custom.css.

  Shortfills, both ways: the box and the pop-up also ask for the FREE nic shots, like the product page does (Infinite Options app):
  100ml = "1st FREE Nic Shot" and "2nd FREE Nic Shot", 50ml = "FREE Nic Shot", each Nic Shot, Ice Shot or Salt Shot.
  They go through as the same order notes (line item properties), so orders look identical to ones from the product page.
  29 Oct 2026: the app's three hidden notes are sent too (see IO_BUNDLE_IDS), so the app adds the shots at checkout.
  Add to basket stays off until both are chosen. If those options are ever changed in Infinite Options, update
  NIC_SHOT_CHOICES and nicShotFields() below. Any other shortfill size opens the product page instead.

  Loaded by layout/theme.liquid on collection and search pages only. Pop-up and pill styles are in assets/custom.css (vdqa- and vd-qs-);
  the box styles are added by this file (vdqb-).
*/
(function () {
  if (window.vdQuickAddInit) return;
  window.vdQuickAddInit = true;
  document.documentElement.classList.add('vd-qa');

  var NIC_SHOT_CHOICES = ['Nic Shot', 'Ice Shot', 'Salt Shot'];

  /* 29 Oct 2026 (Joe and Jack): Infinite Options only adds the free nic shots to the order when the basket line carries
     its own hidden notes, which the product page adds and the quick add did not. Orders 101190 and 101233 went out with
     no shots because of that. The quick add now sends the same three hidden notes, so the app's checkout step treats the
     line exactly like one from the product page. The codes are the app's own ids for the three shot products (the same
     for 100ml and 50ml); if the shot products or the option sets are ever changed in Infinite Options, add a shortfill
     from its product page, look at /cart.js and copy the new codes from _io_product_bundle_ids. */
  var IO_BUNDLE_IDS = {
    'Nic Shot': 'fGZnB3pLdVN4U3ZAaFkxAjEKMxgFNiQWNCA/HyMWZ0IuYGcHLx9xWSwIJEI9XA==',
    'Ice Shot': 'fGZnB3pLdVN7WnBGaV8xAjEKMxgFNiQWNCA/HyMWaUd6ZGxWL0kjWn5adhY8DA==',
    'Salt Shot': 'fGZnB3pLdVN4XHVObV8xAjEKMxgFNiQWNCA/HyMWaBV4YDQLLxxyUnlZdEQ9Cw=='
  };
  function ioHiddenNotes(chosen) {
    var bundles = [], visible = {};
    Object.keys(chosen).forEach(function (field) {
      var v = chosen[field];
      if (v && IO_BUNDLE_IDS[v]) { bundles.push({ bundleId: IO_BUNDLE_IDS[v], name: field }); visible[field] = v; }
    });
    if (!bundles.length) return {};
    return {
      _io_order_group: String(Date.now()),
      _io_product_bundle_ids: JSON.stringify(bundles),
      _io_properties: JSON.stringify(visible)
    };
  }

  var BOX_MIN_WIDTH = '(min-width: 1024px)';
  var PRODUCT_PATH = new RegExp('/products/([^/?#]+)');
  var SELECT_OVER = 8;   /* options with more values than this show as a drop down in the box */

  function nicShotFields(productType) {
    var c = String(productType || '').toLowerCase();
    if (c.indexOf('shortfill') === -1) return null;
    if (c.indexOf('100ml') > -1) return ['1st FREE Nic Shot', '2nd FREE Nic Shot'];
    if (c.indexOf('50ml') > -1) return ['FREE Nic Shot'];
    return 'product-page';
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  function useBox() {
    return window.matchMedia && window.matchMedia(BOX_MIN_WIDTH).matches;
  }

  function money(cents) {
    return '£' + (Number(cents || 0) / 100).toFixed(2);
  }

  var ICON_PLUS = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 4v12M4 10h12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var ICON_BASKET = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 7h18l-1.5 10.5a2 2 0 0 1-2 1.5h-11a2 2 0 0 1-2-1.5L3 7z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/><path d="M8 7a4 4 0 0 1 8 0" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5L5 15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  
  /* ---------- box styles (computers only) ---------- */

  /* 21 Oct 2026 (Joe): laid out like the Boost one on the old live site ("Choose options", the option buttons, then
     quantity and Add to basket on one row), covering the lower part of the card. A little taller than Boost's and
     with slightly bigger option buttons, as Joe asked. */
  var CSS = [
    '.vdqb-host{position:relative}',
    '.vdqb{position:absolute;left:0;right:0;bottom:0;z-index:500;display:flex;flex-direction:column;min-height:215px;max-height:100%;padding:16px 16px 16px;background:#fff;border-top:1px solid #ececf0;border-radius:0 0 14px 14px;box-shadow:0 -8px 20px rgba(20,20,30,.08);font-family:inherit;color:#1d1d1f;text-align:left;cursor:default;animation:vdqb-up .16s ease-out}',
    '@keyframes vdqb-up{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '.vdqb__head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:0 0 12px}',
    '.vdqb__title{margin:0;font-size:15px;font-weight:700;line-height:1.2;color:#1d1d1f}',
    '.vdqb__close{flex:0 0 30px;width:30px;height:30px;margin:0;padding:0;border:0;border-radius:50%;background:#f2f2f5;color:#1d1d1f;display:flex;align-items:center;justify-content:center;cursor:pointer}',
    '.vdqb__close:hover{background:#e6e6ea}',
    '.vdqb__close svg{width:12px;height:12px}',
    '.vdqb__body{flex:1 1 auto;overflow-y:auto;overscroll-behavior:contain;margin:0 -4px;padding:0 4px}',
    '.vdqb__opt{margin:0 0 14px}',
    '.vdqb__label{display:block;margin:0 0 8px;font-size:13px;font-weight:600;color:#6e6e73}',
    '.vdqb__pills{display:flex;flex-wrap:wrap;gap:8px}',
    '.vdqb__pill{min-width:58px;height:40px;margin:0;padding:0 14px;border:1px solid #cfcfd4;border-radius:7px;background:#fff;color:#1d1d1f;font-size:14px;font-weight:500;line-height:1;cursor:pointer}',
    '.vdqb__pill:hover{border-color:#1d1d1f}',
    '.vdqb__pill[aria-pressed="true"]{border-color:#1d1d1f;box-shadow:inset 0 0 0 1px #1d1d1f;font-weight:700}',
    '.vdqb__pill.is-out{color:#a3a3a8;background:#f6f6f8;text-decoration:line-through}',
    '.vdqb__pill.is-out[aria-pressed="true"]{border-color:#a3a3a8;box-shadow:inset 0 0 0 1px #a3a3a8;color:#8a8a90}',
    '.vdqb__select{width:100%;height:42px;margin:0;padding:0 12px;border:1px solid #cfcfd4;border-radius:7px;background:#fff;font-size:14px;color:#1d1d1f}',
    '.vdqb__foot{display:flex;gap:10px;align-items:stretch;margin-top:auto;padding-top:4px}',
    '.vdqb__qty{flex:0 0 auto;display:flex;align-items:stretch;height:48px;border:1px solid #cfcfd4;border-radius:7px;overflow:hidden;background:#fff}',
    '.vdqb__qty button{width:38px;margin:0;padding:0;border:0;background:#fff;color:#1d1d1f;font-size:20px;line-height:1;cursor:pointer}',
    '.vdqb__qty button:hover{background:#f6f6f8}',
    '.vdqb__qty input{width:40px;margin:0;padding:0;border:0;border-left:1px solid #e4e4e9;border-right:1px solid #e4e4e9;border-radius:0;background:#fff;text-align:center;font-size:15px;font-weight:600;color:#1d1d1f;-moz-appearance:textfield}',
    '.vdqb__qty input::-webkit-outer-spin-button,.vdqb__qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}',
    '.vdqb__add{flex:1 1 auto;height:48px;margin:0;padding:0 12px;border:0;border-radius:7px;background:#ed2290;color:#fff;font-size:16px;font-weight:700;cursor:pointer;white-space:nowrap}',
    '.vdqb__add:hover{background:#d41a80}',
    '.vdqb__add[aria-disabled="true"]{background:#e6e6ea;color:#8a8a90;cursor:not-allowed}',
    '.vdqb__add.is-busy{opacity:.7;cursor:progress}',
    '.vdqb__add.is-waiting[aria-disabled="true"]{background:#f5a9d0;color:#fff;font-size:14px;line-height:1.15;white-space:normal}',
    '.vdqb__add.is-done{background:#1f9d55}',
    '.vdqb__msg{margin:8px 0 0;font-size:12.5px;line-height:1.35;color:#c4126f}',
    '.vdqb__msg:empty{display:none}',
    '.vdqb__wait{display:flex;align-items:center;justify-content:center;flex:1 1 auto;min-height:150px}',
    '.vdqb__wait span{width:24px;height:24px;border:3px solid #f3c1dd;border-top-color:#ed2290;border-radius:50%;animation:vdqb-spin .7s linear infinite}',
    '@keyframes vdqb-spin{to{transform:rotate(360deg)}}',
    '.vdqb .vd-nic{margin:0 0 6px}',
    '.vdqb .vd-nic__intro{display:none}',
    '.vdqb .vd-nic__group{margin:0 0 12px}',
    '.vdqb .vd-nic__label{display:block;margin:0 0 8px;font-size:13px;font-weight:600;color:#000}',
    '.vdqb .vd-nic__pills{display:flex;flex-wrap:nowrap;gap:6px}',
    '.vdqb .vd-nic__pill{flex:1 1 0;min-width:0;height:40px;margin:0;padding:0 2px;border:1px solid #cfcfd4;border-radius:7px;background:#fff;color:#1d1d1f;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer}',
    '.vdqb .vd-nic__pill[aria-pressed="true"]{border-color:#1d1d1f;box-shadow:inset 0 0 0 1px #1d1d1f;font-weight:700}',
    '.vd-qa .vdqa-btn.vdqa-btn--done{background:#1f9d55 !important;border-color:#1f9d55 !important}',
    '@media (prefers-reduced-motion:reduce){.vdqb{animation:none}}'
  ].join(' ');

  function addStyles() {
    if (document.getElementById('vdqb-css')) return;
    var s = document.createElement('style');
    s.id = 'vdqb-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---------- product data ---------- */

  var productCache = {};

  function productData(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    productCache[handle].then(function (p) { if (!p) delete productCache[handle]; });
    return productCache[handle];
  }

  function productType(handle) {
    return productData(handle).then(function (p) { return p ? String(p.type || '') : ''; });
  }

  function handleFromItem(item) {
    var url = item.getAttribute('data-product-quickshop-url') || '';
    var m = url.match(PRODUCT_PATH);
    if (m) return m[1];
    var link = item.querySelector('a[href*="/products/"]');
    if (link) {
      m = link.getAttribute('href').match(PRODUCT_PATH);
      if (m) return m[1];
    }
    return '';
  }

  /* ---------- basket ---------- */

  function refreshCounts() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('[data-header-cart-count]').forEach(function (c) {
          c.setAttribute('data-header-cart-count', n > 0 ? n : '');
          c.classList.toggle('visible', n > 0);
        });
        document.querySelectorAll('[data-vbb-count]').forEach(function (c) {
          c.textContent = n;
          c.setAttribute('data-count', n);
        });
        /* the theme's own event, so anything else listening (the header, the phone bottom bar) updates too */
        try { window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart })); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
        return cart;
      })
      .catch(function () { return null; });
  }

  function addToBasket(variantId, quantity, properties) {
    var item = { id: variantId, quantity: quantity };
    if (properties && Object.keys(properties).length) item.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error(data && (data.description || data.message) || 'Sorry, that could not be added.');
          err.vdShow = true;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------- the box inside the card (computers) ---------- */

  var openBox = null;   /* { item, node, close } */

  function closeOpenBox() {
    if (openBox) openBox.close();
  }

  function variantMatches(v, sel) {
    for (var i = 0; i < sel.length; i++) {
      if (sel[i] != null && v.options[i] !== sel[i]) return false;
    }
    return true;
  }

  function findVariant(product, sel) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (variantMatches(v, sel) && sel.every(function (s) { return s != null; })) return v;
    }
    return null;
  }

  /* is there any in stock variant with this value for option i, keeping the other choices made so far? */
  function valueAvailable(product, sel, i, value, ignoreOthers) {
    return product.variants.some(function (v) {
      if (!v.available || v.options[i] !== value) return false;
      if (ignoreOthers) return true;
      for (var j = 0; j < sel.length; j++) {
        if (j !== i && sel[j] != null && v.options[j] !== sel[j]) return false;
      }
      return true;
    });
  }

  function openBoxFor(item, button, handle, badgesHtml, trigger) {
    if (openBox && openBox.item === item) { closeOpenBox(); return; }
    closeOpenBox();
    addStyles();

    var card = item.querySelector('.productitem') || item;
    /* over the lower part of the card, like Boost */
    var host = card;
    host.classList.add('vdqb-host');
    var box = el('div', 'vdqb');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', 'Choose options and add to basket');
    box.innerHTML = '<div class="vdqb__wait"><span></span></div>';
    /* clicks inside the box never reach the card's links */
    box.addEventListener('click', function (e) { e.stopPropagation(); });

    var closed = false;
    var timer = null;
    function close() {
      if (closed) return;
      closed = true;
      clearTimeout(timer);
      if (box.parentNode) box.parentNode.removeChild(box);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onOutside, true);
      if (openBox && openBox.node === box) openBox = null;
      button.setAttribute('aria-expanded', 'false');
    }
    function onKey(e) { if (e.key === 'Escape') { close(); button.focus(); } }
    function onOutside(e) { if (!box.contains(e.target) && !button.contains(e.target)) close(); }
    openBox = { item: item, node: box, close: close };

    function show() {
      if (box.parentNode) return;
      host.appendChild(box);
      document.addEventListener('keydown', onKey);
      setTimeout(function () { if (!closed) document.addEventListener('click', onOutside, true); }, 0);
      button.setAttribute('aria-expanded', 'true');
    }

    function pillDone() {
      /* the pink Add pill says Added for a moment */
      var text = button.querySelector('.vdqa-btn__text');
      var old = text ? text.textContent : '';
      button.classList.add('vdqa-btn--done');
      if (text) text.textContent = 'Added';
      setTimeout(function () {
        button.classList.remove('vdqa-btn--done');
        if (text) text.textContent = old;
      }, 1800);
    }

    productData(handle).then(function (product) {
      if (closed) return;
      if (!product || !product.variants || !product.variants.length || product.requires_selling_plan) {
        /* anything unusual: the theme's own pop-up */
        close();
        trigger.click();
        return;
      }
      var fields = nicShotFields(product.type);
      if (fields === 'product-page') { close(); window.location.href = '/products/' + handle; return; }

      if (product.variants.length === 1 && !Array.isArray(fields)) {
        /* one choice only: straight in, no box, like Boost */
        var v = product.variants[0];
        if (!v.available) { show(); renderMessageOnly('Sorry, this is sold out.'); return; }
        button.classList.add('is-busy');
        addToBasket(v.id, 1, null).then(function () {
          return refreshCounts();
        }).then(function () {
          button.classList.remove('is-busy');
          close();
          pillDone();
        }).catch(function (err) {
          button.classList.remove('is-busy');
          show();
          renderMessageOnly(err && err.vdShow ? err.message : 'Sorry, that could not be added. Please try again.');
        });
        return;
      }
      show();
      render(product, Array.isArray(fields) ? fields : null);
    });
    /* show the spinner only if the product's data is not back almost at once */
    setTimeout(function () { if (!closed && box.querySelector('.vdqb__wait')) show(); }, 150);

    function closeButton() {
      var x = el('button', 'vdqb__close');
      x.type = 'button';
      x.setAttribute('aria-label', 'Close');
      x.innerHTML = ICON_CLOSE;
      x.addEventListener('click', function () { close(); button.focus(); });
      return x;
    }

    function renderMessageOnly(text) {
      box.innerHTML = '';
      var head = el('div', 'vdqb__head');
      head.appendChild(el('p', 'vdqb__title', 'Choose options'));
      head.appendChild(closeButton());
      box.appendChild(head);
      box.appendChild(el('p', 'vdqb__msg', text));
    }

    function render(product, nicFields) {
      var options = product.options || [];
      var optionNames = options.map(function (o) { return typeof o === 'string' ? o : o.name; });
      var hasRealOptions = !(product.variants.length === 1 && /default title/i.test(product.variants[0].title));
      /* start on the first in stock choice, like the product page */
      var start = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      var sel = hasRealOptions ? start.options.slice() : [];

      box.innerHTML = '';
      var head = el('div', 'vdqb__head');
      head.appendChild(el('p', 'vdqb__title', 'Choose options'));
      head.appendChild(closeButton());
      box.appendChild(head);
      var body = el('div', 'vdqb__body');
      box.appendChild(body);

      var optionEls = [];
      if (hasRealOptions) {
        optionNames.forEach(function (name, i) {
          var values = [];
          product.variants.forEach(function (v) { if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]); });
          var wrap = el('div', 'vdqb__opt');
          wrap.appendChild(el('span', 'vdqb__label', name));
          var ui;
          if (values.length > SELECT_OVER) {
            ui = el('select', 'vdqb__select');
            ui.setAttribute('aria-label', name);
            values.forEach(function (val) {
              var o = el('option', '', val);
              o.value = val;
              ui.appendChild(o);
            });
            ui.addEventListener('change', function () { choose(i, ui.value); });
          } else {
            ui = el('div', 'vdqb__pills');
            ui.setAttribute('role', 'group');
            ui.setAttribute('aria-label', name);
            values.forEach(function (val) {
              var b = el('button', 'vdqb__pill', val);
              b.type = 'button';
              b.setAttribute('data-value', val);
              b.addEventListener('click', function () { choose(i, val); });
              ui.appendChild(b);
            });
          }
          wrap.appendChild(ui);
          body.appendChild(wrap);
          optionEls.push({ name: name, ui: ui, values: values });
        });
      }

      /* shortfill free nic shots */
      var nicInputs = [];
      if (nicFields) {
        var nic = el('div', 'vd-nic');
        nicFields.forEach(function (field) {
          var group = el('div', 'vd-nic__group');
          group.appendChild(el('span', 'vd-nic__label', field));
          var pills = el('div', 'vd-nic__pills');
          var holder = { field: field, value: '' };
          nicInputs.push(holder);
          NIC_SHOT_CHOICES.forEach(function (choice) {
            var pill = el('button', 'vd-nic__pill', choice);
            pill.type = 'button';
            pill.setAttribute('aria-pressed', 'false');
            pill.addEventListener('click', function () {
              holder.value = choice;
              pills.querySelectorAll('.vd-nic__pill').forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
              msg.textContent = '';
              update();
            });
            pills.appendChild(pill);
          });
          group.appendChild(pills);
          nic.appendChild(group);
        });
        body.appendChild(nic);
      }

      var foot = el('div', 'vdqb__foot');
      var qty = el('div', 'vdqb__qty');
      var minus = el('button', '', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', 'One less');
      var input = el('input');
      input.type = 'number';
      input.min = '1';
      input.max = '99';
      input.value = '1';
      input.setAttribute('aria-label', 'Quantity');
      var plus = el('button', '', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', 'One more');
      qty.appendChild(minus);
      qty.appendChild(input);
      qty.appendChild(plus);
      function qtyValue() { var n = parseInt(input.value, 10); return isNaN(n) || n < 1 ? 1 : Math.min(n, 99); }
      minus.addEventListener('click', function () { input.value = Math.max(1, qtyValue() - 1); });
      plus.addEventListener('click', function () { input.value = Math.min(99, qtyValue() + 1); });
      input.addEventListener('change', function () { input.value = qtyValue(); });
      var add = el('button', 'vdqb__add', 'Add to basket');
      add.type = 'button';
      foot.appendChild(qty);
      foot.appendChild(add);
      box.appendChild(foot);
      var msg = el('p', 'vdqb__msg');
      box.appendChild(msg);

      function choose(i, value) {
        sel[i] = value;
        /* if that mix is not in stock, move the other choices to the nearest one that is */
        var exact = findVariant(product, sel);
        if (!exact || !exact.available) {
          var alt = product.variants.filter(function (v) { return v.available && v.options[i] === value; });
          if (alt.length) {
            alt.sort(function (a, b) {
              var sa = 0, sb = 0;
              for (var j = 0; j < sel.length; j++) { if (a.options[j] === sel[j]) sa++; if (b.options[j] === sel[j]) sb++; }
              return sb - sa;
            });
            sel = alt[0].options.slice();
          }
        }
        msg.textContent = '';
        update();
      }

      function current() {
        return hasRealOptions ? findVariant(product, sel) : product.variants[0];
      }

      function update() {
        optionEls.forEach(function (o, i) {
          if (o.ui.tagName === 'SELECT') {
            Array.prototype.forEach.call(o.ui.options, function (opt) {
              var inStock = valueAvailable(product, sel, i, opt.value, true);
              opt.textContent = opt.value + (inStock ? '' : ' (sold out)');
              opt.disabled = !inStock;
            });
            o.ui.value = sel[i];
          } else {
            o.ui.querySelectorAll('.vdqb__pill').forEach(function (b) {
              var val = b.getAttribute('data-value');
              b.setAttribute('aria-pressed', val === sel[i] ? 'true' : 'false');
              var any = valueAvailable(product, sel, i, val, true);
              b.classList.toggle('is-out', !valueAvailable(product, sel, i, val, false));
              b.disabled = !any;
              b.title = any ? '' : 'Sold out';
            });
          }
        });
        var v = current();
        var soldOut = !v || !v.available;
        var nicMissing = nicInputs.some(function (h) { return !h.value; });
        /* shortfills: like the old Boost box, the button asks for the free nic shots until they are picked */
        var waiting = !soldOut && nicMissing;
        add.textContent = soldOut ? 'Sold out' : waiting ? (nicInputs.length > 1 ? 'Choose your free nic shots' : 'Choose your free nic shot') : 'Add to basket';
        add.classList.toggle('is-waiting', waiting);
        add.setAttribute('aria-disabled', soldOut || nicMissing ? 'true' : 'false');
      }

      add.addEventListener('click', function () {
        if (add.classList.contains('is-busy') || add.classList.contains('is-done')) return;
        var v = current();
        if (!v || !v.available) { msg.textContent = 'Sorry, that choice is sold out. Please pick another.'; return; }
        if (nicInputs.some(function (h) { return !h.value; })) {
          msg.textContent = nicInputs.length > 1 ? 'Please choose both free nic shots first.' : 'Please choose your free nic shot first.';
          return;
        }
        var props = {};
        nicInputs.forEach(function (h) { props[h.field] = h.value; });
        var ioNotes = ioHiddenNotes(props);
        Object.keys(ioNotes).forEach(function (k) { props[k] = ioNotes[k]; });
        add.classList.add('is-busy');
        add.textContent = 'Adding…';
        addToBasket(v.id, qtyValue(), props).then(function () {
          return refreshCounts();
        }).then(function () {
          add.classList.remove('is-busy');
          add.classList.add('is-done');
          add.textContent = 'Added';
          timer = setTimeout(close, 1200);
        }).catch(function (err) {
          add.classList.remove('is-busy');
          update();
          msg.textContent = err && err.vdShow ? err.message : 'Sorry, that could not be added. Please try again.';
        });
      });

      update();
    }
  }


  /* ---------- cards ---------- */

  function enhance(item) {
    if (item.getAttribute('data-vdqa')) return;
    var card = item.querySelector('.productitem');
    var info = item.querySelector('.productitem--info');
    var price = info && info.querySelector('.productitem__price');
    var trigger = item.querySelector('.productitem--action-trigger');
    if (!card || !price || !trigger) return;
    item.setAttribute('data-vdqa', '1');

    var titleEl = item.querySelector('.productitem--title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var handle = handleFromItem(item);
    var soldOut = trigger.disabled || /sold out/i.test(trigger.textContent);

    var button = el('button', 'vdqa-btn vdqa-btn--pill');
    button.type = 'button';
    if (soldOut) {
      button.disabled = true;
      button.classList.add('vdqa-btn--soldout');
      button.innerHTML = '<span class="vdqa-btn__text">Sold out</span>';
      button.setAttribute('aria-label', title + ' is sold out');
      button.title = 'Sold out';
    } else {
      button.innerHTML = '<span class="vdqa-btn__icon">' + ICON_BASKET + '</span><span class="vdqa-btn__text">Add</span><span class="vdqa-btn__plus">' + ICON_PLUS + '</span>';
      button.setAttribute('aria-label', 'Add to basket: ' + title);
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-expanded', 'false');
      button.title = 'Add to basket';
      /* computers: get the product's data ready while the mouse is over the card */
      card.addEventListener('mouseenter', function () { if (useBox()) productData(handle); }, { once: true });
    }

    price.classList.add('vdqa-price-row');
    price.appendChild(button);

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (button.disabled) return;
      var badges = item.querySelector('.productitem--info .vd-badges');
      var badgesHtml = badges ? badges.innerHTML : '';

      if (useBox() && handle) {
        openBoxFor(item, button, handle, badgesHtml, trigger);
        return;
      }

      current = {
        handle: handle,
        badges: badgesHtml,
        type: productType(handle)
      };
      current.type.then(function (type) {
        /* a shortfill in a size the picker does not know goes to the product page, where every option is on show */
        if (nicShotFields(type) === 'product-page' && handle) window.location.href = '/products/' + handle;
      });
      /* the theme's own quick shop does the rest */
      trigger.click();
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.productgrid--item').forEach(enhance);
  }

  /* a filter change swaps the product grid (assets/vd-ajax-filters.js), so any open box goes with it */
  document.addEventListener('vd:collection:updated', function () { openBox = null; });
  window.addEventListener('resize', function () { if (openBox && !useBox()) closeOpenBox(); });

  /* ---------- the quick shop pop-up (phones and tablets) ---------- */

  var current = null;   /* { handle, badges (HTML or ''), type (promise) } for the card whose + was pressed */

  function decorate(modal) {
    var priceBlock = modal.querySelector('.product-block--price');
    var form = modal.querySelector('form[action*="/cart/add"]');
    if (!priceBlock || !form || !current) return;
    if (modal.querySelector('.vd-qs-extras')) return;

    var extras = el('div', 'product-block vd-qs-extras');
    if (current.badges) {
      var badges = el('div', 'vd-badges vd-badges--product vd-qs-badges');
      badges.innerHTML = current.badges;
      extras.appendChild(badges);
    }
    /* always inserted (empty when there is no deal) so the pop-up is only decorated once */
    priceBlock.parentNode.insertBefore(extras, priceBlock.nextSibling);

    var snapshot = current;
    snapshot.type.then(function (type) {
      var fields = nicShotFields(type);
      if (!Array.isArray(fields)) return;
      if (!modal.contains(form) || form.querySelector('.vd-nic')) return;
      addNicShotFields(modal, form, fields);
    });
  }

  function addNicShotFields(modal, form, fields) {
    var atc = form.querySelector('.product-form--atc-button, button[type="submit"]');
    var wrap = el('div', 'vd-nic');
    wrap.appendChild(el('p', 'vd-nic__intro', fields.length > 1 ? 'Choose your free nic shots' : 'Choose your free nic shot'));
    var selects = [];
    fields.forEach(function (field) {
      var group = el('div', 'vd-nic__group');
      var label = el('span', 'vd-nic__label', field);
      var pills = el('div', 'vd-nic__pills');
      /* the value goes through the form as an order note, the same name Infinite Options uses on the product page */
      var hidden = el('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + field + ']';
      hidden.value = '';
      selects.push(hidden);
      NIC_SHOT_CHOICES.forEach(function (choice) {
        var pill = el('button', 'vd-nic__pill', choice);
        pill.type = 'button';
        pill.setAttribute('aria-pressed', 'false');
        pill.addEventListener('click', function () {
          hidden.value = choice;
          pills.querySelectorAll('.vd-nic__pill').forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
          refresh();
        });
        pills.appendChild(pill);
      });
      group.appendChild(label);
      group.appendChild(pills);
      group.appendChild(hidden);
      wrap.appendChild(group);
    });
    var note = el('p', 'vd-nic__note');
    wrap.appendChild(note);
    /* the app's hidden notes, filled in once every shot is chosen (see IO_BUNDLE_IDS) */
    var ioInputs = {};
    ['_io_order_group', '_io_product_bundle_ids', '_io_properties'].forEach(function (name) {
      var h = el('input');
      h.type = 'hidden';
      h.name = 'properties[' + name + ']';
      h.value = '';
      h.disabled = true;
      wrap.appendChild(h);
      ioInputs[name] = h;
    });
    function syncIo() {
      var chosen = {};
      fields.forEach(function (field, i) { chosen[field] = selects[i].value; });
      var notes = missing() ? {} : ioHiddenNotes(chosen);
      Object.keys(ioInputs).forEach(function (name) {
        ioInputs[name].value = notes[name] || '';
        ioInputs[name].disabled = !notes[name];
      });
    }

    /* sits just above the quantity and Add to basket row */
    var atcRow = form.querySelector('.product-form--atc');
    if (atcRow && atcRow.parentNode) atcRow.parentNode.insertBefore(wrap, atcRow);
    else form.appendChild(wrap);

    function missing() { return selects.some(function (s) { return !s.value; }); }
    function refresh() {
      syncIo();
      if (!atc) return;
      if (missing()) {
        atc.classList.add('vd-nic__atc-off');
        atc.setAttribute('aria-disabled', 'true');
        note.textContent = '';
      } else {
        atc.classList.remove('vd-nic__atc-off');
        atc.removeAttribute('aria-disabled');
        note.textContent = '';
      }
    }
    if (atc) {
      /* runs before the theme's own handler: nothing is added until the nic shots are chosen */
      atc.addEventListener('click', function (e) {
        if (!missing()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        note.textContent = fields.length > 1 ? 'Please choose both free nic shots first.' : 'Please choose your free nic shot first.';
        wrap.scrollIntoView({ block: 'nearest' });
      }, true);
    }
    refresh();
  }

  /* the theme fills the pop-up after it opens, so watch for the product form arriving */
  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      scan();
      var modal = document.querySelector('.modal--quickshop-slim, .modal--quickshop-full');
      if (modal && document.body.classList.contains('modal-visible')) decorate(modal);
    }, 60);
  });

  function start() {
    scan();
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
